/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as import0 from '@angular/core';
import * as import1 from './option.component';
const styles_OptionComponent:any[] = ([] as any[]);
export const RenderType_OptionComponent:import0.RendererType2 = import0.ɵcrt({
  encapsulation: 2,
  styles: styles_OptionComponent,
  data: {}
}
);
export function View_OptionComponent_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,([] as any[]),(null as any),(null as any));
}
function View_OptionComponent_Host_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'woa-option',([] as any[]),(null as any),(null as any),(null as any),View_OptionComponent_0,RenderType_OptionComponent)),
    import0.ɵdid(573440,(null as any),0,import1.OptionComponent,([] as any[]),(null as any),(null as any))
  ]
  ,(null as any),(null as any));
}
export const OptionComponentNgFactory:import0.ComponentFactory<import1.OptionComponent> = import0.ɵccf('woa-option',import1.OptionComponent,View_OptionComponent_Host_0,{
  label: 'label',
  value: 'value'
}
,{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL2hvbWUvcnVubmVyL3dvcmsvd2ViLW9yZGVyaW5nLWFwcC93ZWItb3JkZXJpbmctYXBwL3NyYy9hcHAvaW5wdXRzL3NlbGVjdGlvbi1maWVsZC9vcHRpb24uY29tcG9uZW50Lm5nZmFjdG9yeS50cyIsInZlcnNpb24iOjMsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm5nOi8vL2hvbWUvcnVubmVyL3dvcmsvd2ViLW9yZGVyaW5nLWFwcC93ZWItb3JkZXJpbmctYXBwL3NyYy9hcHAvaW5wdXRzL3NlbGVjdGlvbi1maWVsZC9vcHRpb24uY29tcG9uZW50LnRzIiwibmc6Ly8vaG9tZS9ydW5uZXIvd29yay93ZWItb3JkZXJpbmctYXBwL3dlYi1vcmRlcmluZy1hcHAvc3JjL2FwcC9pbnB1dHMvc2VsZWN0aW9uLWZpZWxkL29wdGlvbi5jb21wb25lbnQudHMuT3B0aW9uQ29tcG9uZW50X0hvc3QuaHRtbCJdLCJzb3VyY2VzQ29udGVudCI6WyIgIiwiPHdvYS1vcHRpb24+PC93b2Etb3B0aW9uPiJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7SUNBQTtnQkFBQTs7Ozs7Ozs7In0=



// WEBPACK FOOTER //
// ./src/app/inputs/selection-field/option.component.ngfactory.ts